import { useContext } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { trackClickManageSeats } from '../utils/event-handlers';
import BannerContent from './BannerContent';
import { jsx as _jsx } from "react/jsx-runtime";
const ManageSeatsBanner = ({
  onClose
}) => {
  const trackUsage = useContext(TrackUsageContext);
  return /*#__PURE__*/_jsx(BannerContent, {
    onClose: onClose,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link
      },
      message: "routing-ui.routingRules.roundRobin.manageSeatsFooter_jsx",
      options: {
        external: true,
        href: getUsersSeatsUrl(),
        onClick: () => trackUsage(trackClickManageSeats())
      }
    })
  });
};
ManageSeatsBanner.displayName = 'ManageSeatsBanner';
export default ManageSeatsBanner;